import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

export default function Slider({data}) {

    let imgs = [];
    for (const i of data) {
        const obj = {
            original: i,
            thumbnail: i,
            thumbnailHeight: '100px'
        };
        imgs.push(obj)
    };
    
    return data && <ImageGallery items={imgs} showPlayButton={false}/>;
}